import React from 'react';
import { Button, FormControl, FormHelperText, Grid, MenuItem, Select, Stack, TextField } from '@mui/material';
import { Box } from '@mui/system';
import { Printer, Trash2 } from 'lucide-react';
import { DEFAULT_PAPER, SUPPORTED_PAPERS } from './paperSizes';

const defaultPaper = DEFAULT_PAPER;
const supportedPapers = SUPPORTED_PAPERS;

// Toolbar for a sheet: rename, pick paper size, delete, print.
export function SheetSettingsPanel({ proxy, onNameChange, onNameBlur, onPaperChange, onDelete, onPrint, sheetFits }) {
    const paperItems = Object.keys(supportedPapers).map(p => <MenuItem value={supportedPapers[p].name} key={p}>{p}</MenuItem>);

    return (
        <Stack direction="row" spacing={2} xs={6} alignItems="flex-end">
            <FormControl>
                <FormHelperText>Sheet name</FormHelperText>
                <TextField value={proxy ? proxy.name : ""} onBlur={onNameBlur} onChange={e => onNameChange(e.target.value)} />
            </FormControl>
            <FormControl>
                <FormHelperText>Paper size</FormHelperText>
                <Select value={proxy.papersize ? proxy.papersize.name : defaultPaper.name} onChange={e => onPaperChange(supportedPapers[e.target.value])}>
                    {paperItems}
                </Select>
            </FormControl>
            <Box xs={6} alignItems="flex-end" justifyContent="space-around">
                <Grid item xs={12}>
                    <Stack direction="row" spacing={2} alignItems="flex-end" justifyContent="space-evenly">
                        <Button size="small" variant="outlined" color="error" onClick={onDelete} startIcon={<Trash2 size={18} strokeWidth={2} />}>
                            Delete
                        </Button>
                        <Button size="small" variant="outlined" color="primary" onClick={onPrint} startIcon={<Printer size={18} strokeWidth={2} />} disabled={!sheetFits}>
                            Print
                        </Button>
                    </Stack>
                </Grid>
            </Box>
        </Stack>
    );
}
